import { ADD_ALERT } from "@/store/_actiontypes";
import store from "@/store";

export class Toast {
    static _show(message, color) {
        store.dispatch(`alert/${ADD_ALERT}`,
            { message, color },
            { root: true },
        );
    }

    static success(message) {
        this._show(message, "success");
    }

    static error(message) {
        this._show(message, "error");
    }

    static warning(message) {
        this._show(message, "warning");
    }

    static info(message) {
        this._show(message, "info");
    }
}